import * as moment from 'moment';
import * as XLSX from 'xlsx-js-style';

const outputObjAry = ({ data = [], fileName = '' }) => {
  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(data);
};

const outputAryAry = ({
  data = [],
  fileName = '',
  header = [],
  wrapText = false,
}) => {
  const wb = XLSX.utils.book_new();
  // const ws = XLSX.utils.json_to_sheet(data);
  const ws = {};
  const finalData = header.length ? [header, ...data] : data;
  if (data.length > 0) {
    finalData.forEach((o, i) => {
      o.forEach((o2, i2) => {
        ws[`${XLSX.utils.encode_col(i2)}${XLSX.utils.encode_row(i)}`] = {
          t: 's',
          v: o2,
          s: {
            alignment: { wrapText },
            font: { sz: '12' },
          },
        };
        if ((i === (finalData.length - 1)) && (i2 === (o.length - 1))) ws['!ref'] = `A1:${XLSX.utils.encode_col(i2)}${XLSX.utils.encode_row(i)}`;
      });
    });
    XLSX.utils.book_append_sheet(wb, ws, 'sheet_1');
    XLSX.writeFile(wb, `${fileName}${moment().format('YYYYMMDD')}.xlsx`);
  }
};

export default { outputObjAry, outputAryAry };
